<template>
  <div class="flex">
    <div class="w-1/2">&#189;</div>
    <div class="w-1/2">
      <svg-icon type="mdi" :path="path"></svg-icon>
    </div>
  </div>
</template>

<script>
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiBriefcase } from "@mdi/js"

export default {
  name: "HalfWorkdayIcon",
  components: {
    SvgIcon
  },
  data() {
    return {
      path: mdiBriefcase,
    }
  }
}
</script>
